module.exports = __webpack_public_path__ + "static/media/diary-pic.eb10feb6.png";